import './polyfills/globalThis';
import './polyfills/intl';
import './polyfills/objectFromEntries';
import './polyfills/visualViewport';
import './polyfills/resizeObserver';
